// extracted by mini-css-extract-plugin
export var aboutHeading = "about-module--about-heading--kZXGC";
export var aboutNoMarginTop = "about-module--about-no-margin-top--1BYoF";